<template>
    <main v-if="loading" id="js-page-content" class="stats-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('post.page.choiceviewlistposts.statisticsview') }}</div>
        </portal>

        <header class="stats-hero">
            <div class="stats-hero-text">
                <h1 class="stats-hero-title">{{ $t('post.page.choiceviewlistposts.statisticsview') }}</h1>
                <p class="stats-hero-sub">
                    {{ $t('post.page.statistics.subtitle') || 'Vue d\'ensemble des tickets sur la période.' }}
                </p>
            </div>
            <MultipleListCreate class="stats-multi-list" />
        </header>

        <section v-if="defaultsDashboard.length" class="stats-grid">
            <DefaultDashboard
                v-for="defaultDashboard in defaultsDashboard"
                :key="defaultDashboard.id"
                :type="defaultDashboard.type_module"
                :uuid="defaultDashboard.module_uuid"
            />
        </section>

        <section v-if="premiumsDashboard.length" class="stats-grid">
            <PremiumDashboard
                v-for="premium in premiumsDashboard"
                :key="premium.id"
                :type="premium.type_module"
                :uuid="premium.module_uuid"
            />
        </section>

        <section class="stats-grid">
            <BarChart
                :titleChart="$t(`post.page.statistics.title.bymonth`)"
                headingChart=""
                chartId="barChartIdMois"
                :chartData="barChartDataMois"
            />
            <BarChart
                :titleChart="$t(`post.page.statistics.title.byweek`)"
                headingChart=""
                chartId="barChartIdSemaine"
                :chartData="barChartData"
            />
        </section>
    </main>
</template>

<script>
import MultipleListCreate from '@/components/UI/MultipleListCreate'
import DefaultDashboard from '@/components/UI/DefaultDashboard'
import PremiumDashboard from '@/components/UI/PremiumDashboard'
import BarChart from '@/components/UI/BarChart'
import DashboardService from '@/services/dashboard/DashboardService'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'Statistiques',
    components: {
        MultipleListCreate,
        BarChart,
        DefaultDashboard,
        PremiumDashboard
    },
    data() {
        return {
            defaultsDashboard: [],
            premiumsDashboard: [],
            loading: true,
            statistics: null,
            chartDataOpenResolved: {
                type: 'pie',
                data: {
                    labels: [],
                    datasets: [
                        {
                            borderColor: ['#fff ', '#fff'],
                            backgroundColor: ['#3B82F6 ', '#10B981'],
                            data: []
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top'
                        },
                        datalabels: {
                            color: '#FFFFFF',
                            font: {
                                weight: 'bold',
                                size: 16
                            }
                        }
                    }
                }
            },
            chartDataResponse: {
                type: 'pie',
                data: {
                    labels: [],
                    datasets: [
                        {
                            borderColor: ['#fff ', '#fff'],
                            backgroundColor: ['#EF4444 ', '#10B981'],
                            data: []
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top'
                        },
                        datalabels: {
                            color: '#FFFFFF',
                            font: {
                                weight: 'bold',
                                size: 16
                            }
                        }
                    }
                }
            },
            chartDataAssigned: {
                type: 'pie',
                data: {
                    labels: ['Non assignés', 'Assignés'],
                    datasets: [
                        {
                            borderColor: ['#fff ', '#fff'],
                            backgroundColor: ['#EF4444 ', '#10B981'],
                            data: [30, 67]
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top'
                        },
                        datalabels: {
                            color: '#FFFFFF',
                            font: {
                                weight: 'bold',
                                size: 16
                            }
                        }
                    }
                }
            },
            chartDataStatus: {
                type: 'pie',
                data: {
                    labels: [],
                    datasets: [
                        {
                            borderColor: ['#fff ', '#fff', '#fff'],
                            backgroundColor: ['#FBBF24', '#3B82F6', '#10B981'],
                            data: []
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top'
                        },
                        datalabels: {
                            color: '#FFFFFF',
                            font: {
                                weight: 'bold',
                                size: 16
                            }
                        }
                    }
                }
            },
            barChartData: {
                type: 'line',
                data: {
                    labels: [],
                    datasets: [
                        {
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(8, 145, 178, 0.08)',
                            borderColor: '#0891B2',
                            borderWidth: 2,
                            pointBackgroundColor: '#0891B2',
                            pointBorderColor: '#fff',
                            pointBorderWidth: 2,
                            pointRadius: 5,
                            pointHoverRadius: 7,
                            tension: 0.3
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: {
                            display: false
                        },
                        datalabels: {
                            color: '#FFFFFF',
                            font: {
                                weight: 'bold',
                                size: 16
                            }
                        }
                    }
                }
            },
            barChartDataMois: {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                        {
                            data: [],
                            fill: false,
                            backgroundColor: '#0891B2'
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: {
                            display: false
                        },
                        datalabels: {
                            color: '#FFFFFF',
                            font: {
                                weight: 'bold',
                                size: 16
                            }
                        }
                    }
                }
            }
            // barChartDataJour: {
            //   type: 'bar',
            //   data: {
            //     labels: ['9h', '10h', '14h', '15h', '16h', '17h', '18h'],
            //     datasets: [
            //       {
            //         data: [],
            //         fill: false,
            //         backgroundColor: '#0891B2',
            //       },
            //     ],
            //   },
            //   options: {
            //     legend: {
            //       display: false,
            //     },
            //     plugins: {
            //       datalabels: {
            //         color: '#FFFFFF',
            //         font: {
            //           weight: 'bold',
            //           size: 16,
            //         },
            //       },
            //     },
            //   },
            // },
        }
    },
    computed: {
        ...mapState('post', {
            config: (state) => state.postsConfig
        }),
        ...mapState('status', {
            statuses: (state) => state.statuses
        })
    },
    created() {
        new DashboardService()
            .getDashboard('default')
            .then((response) => {
                this.defaultsDashboard = response
            })
            .catch((e) => console.error(e))
        new DashboardService()
            .getDashboard()
            .then((response) => {
                this.premiumsDashboard = response
            })
            .catch((e) => console.error(e))
        this.getData()
    },
    methods: {
        ...mapActions('post', ['getVolumetry']),
        addData(chart, label, data) {
            chart.data.labels.push(label)
            chart.data.datasets[0].data.push(data)
        },
        renameLabelSolved(label) {
            return this.$t(`post.page.statistics.label.solved.${label}`)
        },
        renameLabelAnswered(label) {
            return this.$t(`post.page.statistics.label.answered.${label}`)
        },
        renameLabelWeek(label) {
            return this.$t(`post.page.statistics.label.weekday.${label}`)
        },
        renameLabelMonth(label) {
            return this.$t(`post.page.statistics.label.month.${label}`)
        },
        getData() {
            this.getVolumetry()
                .then((response) => {
                    this.loading = false
                    this.statistics = response.data
                    this.statistics.countStatusSolved.forEach((el) =>
                        this.addData(
                            this.chartDataOpenResolved,
                            this.renameLabelSolved(el['solved']),
                            el['count']
                        )
                    )
                    this.statistics.countWithResponses.forEach((el) =>
                        this.addData(
                            this.chartDataResponse,
                            this.renameLabelAnswered(el['answered']),
                            el['count']
                        )
                    )
                    this.statistics.countStatusOpened.forEach((el) =>
                        this.addData(
                            this.chartDataStatus,
                            el['name'],
                            el['count']
                        )
                    )
                    // Sort months 1-12
                    const monthOrder = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
                    const sortedMonths = [...this.statistics.countbyMonth].sort(
                        (a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month)
                    )
                    sortedMonths.forEach((el) =>
                        this.addData(
                            this.barChartDataMois,
                            this.renameLabelMonth(el['month']),
                            el['count']
                        )
                    )

                    // Sort days: Monday(1) to Sunday(7)
                    const dayOrder = [1, 2, 3, 4, 5, 6, 7]
                    const sortedDays = [...this.statistics.countbyDayofWeek].sort(
                        (a, b) => dayOrder.indexOf(a.day_of_week) - dayOrder.indexOf(b.day_of_week)
                    )
                    sortedDays.forEach((el) =>
                        this.addData(
                            this.barChartData,
                            this.renameLabelWeek(el['day_of_week']),
                            el['count']
                        )
                    )
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = true
                })
        }
    }
}
</script>

<style scoped>
.stats-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.stats-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--v2-space-4);
    margin-bottom: var(--v2-space-5);
}

.stats-hero-text {
    min-width: 0;
}

.stats-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.stats-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.stats-multi-list {
    flex-shrink: 0;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
    gap: var(--v2-space-4);
    margin-bottom: var(--v2-space-4);
}

@media (max-width: 900px) {
    .stats-v2 {
        padding: 16px 18px 32px;
    }

    .stats-hero {
        flex-direction: column;
        align-items: stretch;
        gap: var(--v2-space-3);
    }

    .stats-hero-title {
        font-size: 1.375rem;
    }

    .stats-grid {
        grid-template-columns: 1fr;
        gap: var(--v2-space-3);
    }
}
</style>
